export default __webpack_public_path__ + "static/Plots0017-a6a2c1a01cedfa3bda12f12b8df8f501.jpg";